<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="payMannerRegisters"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button
            type="danger"
            @click="deleteIds">
          批量删除
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="customerName" align="center" label="客户名称"/>
      <el-table-column prop="payMannerType" align="center" label="付款方式"/>
      <el-table-column prop="isForever" align="center" label="永久有效">
        <template slot-scope="scope">
          <span>
            {{scope.row.isForever === 1 ? "是":"否"}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="beignDate" align="center" label="开始日期">
        <template slot-scope="scope">
          <span>
            {{scope.row.isForever === 1 ? "": scope.row.beignDate}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="endDate" align="center" label="结束日期">
        <template slot-scope="scope">
          <span>
            {{scope.row.isForever === 1 ? "": scope.row.endDate}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          <el-button type="primary" @click="$refs.editCustomerPayMethod.open(scope.row.pmrid)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <customer-pay-method-edit ref="editCustomerPayMethod" @save-success="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import CustomerPayMethodEdit from "@/views/information/CustomerPayMethod/CustomerPayMethodEdit";

  export default {
    name: "CustomerPayMethodList",
    components: {CustomerPayMethodEdit, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          customerName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.customerID);
          }
          //console.log(ids);
          this.$http
            .delete("basic","payMannerRegisters/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","payMannerRegisters",row.pmrid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
